import { render, staticRenderFns } from "./DepartmentEditInputs.vue?vue&type=template&id=53b848c6&"
import script from "./DepartmentEditInputs.vue?vue&type=script&lang=js&"
export * from "./DepartmentEditInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports